import React from 'react';
import { Logo, Typography } from '@bonprix/design-system';

export default function AcceptedPaymentSection({texts, paymentTypes = [], country, guest, isCartPage }) {

    const isAnonymous = paymentTypes.length === 0;
    const showInvoice = paymentTypes.includes('BILLING') || isAnonymous;
    const showInstalment = ((paymentTypes.includes('BILLING') || isAnonymous) && country === 'de') || paymentTypes.includes('DEPOSIT');
    const showPartPayment = (paymentTypes.includes('REVOLVING_CREDIT') || (isAnonymous && country === 'at'));
    const showSepa = (paymentTypes.includes('BANK_COLLECTION') || (isAnonymous && country === 'de'));
    const showPaypal = paymentTypes.includes('PAYPAL') || isAnonymous;
    const showCreditCards = paymentTypes.includes('CREDIT_CARD') || isAnonymous;
    const showAmex = showCreditCards && country === 'de';
    const showPrepaid = paymentTypes.includes('PREPAID') || isAnonymous;

    const weAcceptText = guest ? texts.checkout__accepted_payment_types_guest : texts.cot09_accepted_payment_types;
    const weAcceptTextAlignment = isCartPage ? 'center' : 'left';

    return (
        <div className="flex flex-col gap-2">
            <Typography variant="body2" align={weAcceptTextAlignment}>{weAcceptText}</Typography>
            <ul className="flex flex-wrap gap-1 pl-0">
                { showInvoice && <AcceptedPaymentType type="payment-invoice" label={texts.checkout__payment_billing_screenreader_label} /> }
                { showInstalment && <AcceptedPaymentType type="payment-instalment" label={texts.checkout__payment_installment_screenreader_label} /> }
                { showPartPayment && <AcceptedPaymentType type="payment-part-payment" label={texts.checkout__payment_revolvingcredit_screenreader_label} /> }
                { showSepa && <AcceptedPaymentType type="payment-sepa" label={texts.checkout__payment_sepa_screenreader_label} /> }
                { showPaypal && <AcceptedPaymentType type="payment-paypal" label={texts.checkout__payment_paypal_screenreader_label} /> }
                { showCreditCards && <AcceptedPaymentType type="payment-visa" label={texts.checkout__payment_visa_screenreader_label} /> }
                { showCreditCards && <AcceptedPaymentType type="payment-mastercard" label={texts.checkout__payment_mastercard_screenreader_label} /> }
                { showAmex && <AcceptedPaymentType type="payment-american-express" label={texts.checkout__payment_amex_screenreader_label} /> }
                { showCreditCards && <AcceptedPaymentType type="payment-diners-club" label={texts.checkout__payment_dinersclub_screenreader_label} /> }
                { showCreditCards && <AcceptedPaymentType type="payment-discover" label={texts.checkout__payment_discover_screenreader_label} /> }
                { showPrepaid && <AcceptedPaymentType type="payment-prepayment" label={texts.checkout__payment_prepayment_screenreader_label} /> }
            </ul>
        </div>
    )
}

const AcceptedPaymentType = ({type, label}) => {
    return (
        <li className="flex items-center justify-center p-0.5 rounded h-6 w-11 border border-solid border-clr-bg-disabled">
            <Logo variant={type} className="max-h-full max-w-full" label={label} />
        </li>
    )
}

